import React from 'react';
import Reflux from 'reflux';
import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import { OrderedMap, Map } from 'immutable';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import TeamViewStore from 'flux/stores/TeamViewStore';
import EventViewStore from 'flux/stores/EventViewStore';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import UserSessionStore from 'flux/stores/UserSessionStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import RouteActions from 'shared/flux/actions/RouteActions';
import CuesheetColumnActions from 'shared/flux/actions/cuesheet/CuesheetColumnActions';
import PureRenderMixin from 'react-pure-render/mixin';
import ColumnMenuMixin from 'main/components/show/cuesheet/columnHeaderCell/columnMenuMixin';
import ConfirmActions from 'flux/actions/ConfirmActions';
import KeyModifierConstants from 'shared/constants/KeyModifierConstants.jsx';
import MessageConstants from 'shared/constants/Messages';
import WidthMenuItem from 'main/components/show/cuesheet/columnHeaderCell/widthMenuItem';
import { isMac } from 'shared/lib/platformCheck';
import UserActions from 'shared/flux/actions/UserActions';
import { ViewTypes, ViewRelativePaths } from 'shared/constants/CuesheetViews';
import { isGlobalElementManager } from 'main/components/show/cuesheet/cuesheetViewHelper';

import { populatePrompterSettingsWithDefaults } from 'shared/constants/FeaturedEditorConstants';

import {
  NoteColumnHeaderTitle,
  ProofColumnHeaderTitle,
} from 'flux/stores/cuesheet/CuesheetConstants';

import role from 'shared/lib/role';

export default React.createClass({
  displayName: 'ColumnMenu',

  mixins: [
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    Reflux.connectFilter(CuesheetStore, 'userSettings', (state) => {
      return state.get('userSettings');
    }),
    Reflux.connectFilter(CuesheetStore, 'rows', (state) => {
      return state.get('rows');
    }),
    Reflux.connectFilter(UserSessionStore, 'proofColumnHidden', (state) => {
      return state.getIn(['preferences', 'displayProofOfPerformance']) !== true;
    }),
    PureRenderMixin,
    ColumnMenuMixin,
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(TeamViewStore, 'team'),
    Reflux.connect(EventViewStore, 'event'),
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const showMenu = this.state.popoverVisibility.get(
      this.props.column.get('_id'),
    );

    return (
      <PopoverMenu
        className="cs-data-column-menu"
        config={this._getConfigData()}
        show={showMenu}
      />
    );
  },

  _getConfigData() {
    const id = this._getColumnId();
    const { column } = this.props;
    const { teamId, eventId } = this.context.router.state.params;
    const hasEventAdmin = role.hasEventAdminRole(
      this.state.user,
      teamId,
      eventId,
    );

    // userSettings, team, event
    const { userSettings } = this.state;
    const noteColumnHidden = userSettings.getIn(['noteColumn', 'hidden']);

    const items = OrderedMap({
      hideColumn: Map({
        hidden: isGlobalElementManager(),
        content: (
          <span>
            Hide Column
            {this._getKeyModifier('hideColumn')}
          </span>
        ),
        onClick: () => this._handleHideColumnClick(),
      }),
      showAllColumns: Map({
        hidden: isGlobalElementManager(),
        divider: true,
        content: (
          <span>
            Show All Columns
            {this._getKeyModifier('showAllColumns')}
          </span>
        ),
        onClick: () => this._handleShowAllColumnsClick(),
      }),
      showMyNotesColumn: Map({
        hidden: noteColumnHidden !== true,
        divider: true, //This nothing but need to add support for it
        content: `Show "${NoteColumnHeaderTitle}" Column`,
        onClick: () => this._handleShowMyNotesColumnClick(),
      }),
      showProofColumn: Map({
        hidden:
          this.state.proofColumnHidden !== true || isGlobalElementManager(),
        divider: true,
        content: `Show "${ProofColumnHeaderTitle}" Column`,
        onClick: () => this._handleShowProofColumnClick(),
      }),
      moveUserColumnLeft: Map({
        hidden: isGlobalElementManager(),
        content: (
          <span>
            Move Column Left
            {this._getKeyModifier('moveColumnLeft')}
          </span>
        ),
        onClick: () => this._handleMoveColumnLeftClick(),
      }),
      moveUserColumnRight: Map({
        hidden: isGlobalElementManager(),
        divider: true,
        content: (
          <span>
            Move Column Right
            {this._getKeyModifier('moveColumnRight')}
          </span>
        ),
        onClick: () => this._handleMoveColumnRightClick(),
      }),
      setWidthUltraNarrow: Map({
        hidden: !hasEventAdmin,
        content: (
          <WidthMenuItem
            keyModifier="widthShrink"
            label="Ultra Narrow"
            currentWidth={column.get('width')}
            width="ultraNarrow"
          />
        ),
        onClick: () => this._handleSetColumnWidthClick('ultraNarrow'), //TODO: use CuesheetConstant
      }),
      setWidthNarrow: Map({
        hidden: !hasEventAdmin,
        content: (
          <WidthMenuItem
            keyModifier="widthShrink"
            label="Narrow"
            currentWidth={column.get('width')}
            width="narrow"
          />
        ),
        onClick: () => this._handleSetColumnWidthClick('narrow'), //TODO: use CuesheetConstant
      }),
      setWidthNormal: Map({
        hidden: !hasEventAdmin,
        content: (
          <WidthMenuItem
            keyModifier="widthShrink"
            label="Normal"
            currentWidth={column.get('width')}
            width="normal"
          />
        ),
        onClick: () => this._handleSetColumnWidthClick('normal'), //TODO: use CuesheetConstant
      }),
      setWidthWide: Map({
        hidden: !hasEventAdmin,
        content: (
          <WidthMenuItem
            keyModifier="widthGrow"
            label="Wide"
            currentWidth={column.get('width')}
            width="wide"
          />
        ),
        onClick: () => this._handleSetColumnWidthClick('wide'), //TODO: use CuesheetConstant
      }),
      setWidthScriptWide: Map({
        hidden: !hasEventAdmin,
        divider: true,
        content: (
          <WidthMenuItem
            keyModifier="widthGrow"
            label="Script Wide"
            currentWidth={column.get('width')}
            width="scriptWide"
          />
        ),
        onClick: () => this._handleSetColumnWidthClick('scriptWide'), //TODO: use CuesheetConstant
      }),
      teleprompterView: Map({
        hidden: isGlobalElementManager(),
        content: 'Take To Prompter View',
        onClick: () => this._handleTeleprompterView(),
      }),
      featuredView: Map({
        hidden: isGlobalElementManager(),
        divider: true,
        content: 'Take To Featured View',
        onClick: () => this._handleFeaturedView(),
      }),
      addColumnToEnd: Map({
        hidden: !hasEventAdmin,
        divider: true,
        content: 'Add Column To End',
        onClick: () => this._handleAddColumnToEndClick(),
      }),
      deleteItem: Map({
        hidden: !hasEventAdmin,
        content: 'Delete Column',
        onClick: () => this._handleDeleteColumnClick(),
      }),
    }).filter((item) => item.get('hidden') !== true);

    return Map({
      id,
      noCaret: false,
      icon: 'angle-down',
      placement: 'bottom',
      onClick: () => PopoverActions.show(id),
      onHide: () => PopoverActions.hide(id),
      items,
    });
  },

  _handleFeaturedView() {
    const columnId = this._getColumnId();
    const { user } = this.state;
    const { teamId, eventId, showId } = this.props;

    CuesheetColumnActions.saveFeaturedColumn(columnId);
    UserActions.updatePreference(
      user.get('_id'),
      'cuesheetView',
      ViewTypes.Featured,
    );
    RouteActions.goToShow({
      teamId,
      eventId,
      showId,
      relativePath: ViewRelativePaths.Featured,
    });
  },

  _handleTeleprompterView() {
    const columnId = this._getColumnId();

    CuesheetColumnActions.saveFeaturedColumn(columnId);

    this._routeToTeleprompter();
  },

  _routeToTeleprompter() {
    const { teamId, eventId, showId } = this.props;
    const { userSettings, rows } = this.state;

    const query = populatePrompterSettingsWithDefaults(userSettings);

    const rowId = rows.getIn([0, 'path'])[2];
    const columnId = this._getColumnId();

    const params = { teamId, eventId, showId, columnId, rowId };

    RouteActions.goToTeleprompter(params, query);
  },

  _getKeyModifier(type) {
    const command = isMac()
      ? KeyModifierConstants.macKeys[type]
      : KeyModifierConstants.windowsKeys[type];

    return <span className="shortcut-key-modifier">{command}</span>;
  },

  _getColumnId() {
    return this.props.column.get('_id');
  },

  _handleHideColumnClick() {
    CuesheetColumnActions.hideColumn(this._getColumnId());
  },

  _handleShowAllColumnsClick() {
    CuesheetColumnActions.showColumns();
  },

  _handleShowMyNotesColumnClick() {
    CuesheetColumnActions.showNoteColumn();
  },

  _handleShowProofColumnClick() {
    UserActions.updatePreference(
      this.state.user.get('_id'),
      'displayProofOfPerformance',
      true,
    );
  },

  _handleMoveColumnLeftClick() {
    CuesheetColumnActions.moveUserColumnLeft(this._getColumnId());
  },

  _handleMoveColumnRightClick() {
    CuesheetColumnActions.moveUserColumnRight(this._getColumnId());
  },

  _handleAddColumnToEndClick() {
    if (isGlobalElementManager()) {
      ConfirmActions.prompt(
        MessageConstants.addOrDeleteGlobalColumnWarning,
        () => CuesheetColumnActions.addColumn(),
      );
    } else {
      CuesheetColumnActions.addColumn();
    }
  },

  _handleDeleteColumnClick() {
    const confirmAction = () =>
      CuesheetColumnActions.deleteColumn(this._getColumnId());

    if (isGlobalElementManager()) {
      ConfirmActions.prompt(
        MessageConstants.addOrDeleteGlobalColumnWarning,
        confirmAction,
      );
    } else {
      const confirmQuestion =
        'Are you sure you want to delete column ' +
        this.props.column.get('title') +
        '?';
      ConfirmActions.prompt(confirmQuestion, confirmAction);
    }
  },

  _handleSetColumnWidthClick(width) {
    CuesheetColumnActions.updateColumnWidth(this._getColumnId(), width);
  },
});
